exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltip.permission-description .tooltip-inner {\n  font-size: 125%;\n  text-align: left;\n  line-height: 1.5;\n  padding: 24px;\n  min-width: 550px;\n}", ""]);

// exports
